<template>
  <div class="content-main">
    <HeaderBar :text="headerBar.text" :backgroundUrl="headerBar.backgroundUrl"></HeaderBar>
    <div class="content">
      <div class="container">
        <div class="web-img">
          <img :src="`/${$staticPath}/${mainImg.src}`" :key="mainImg.index" data-aos="fade" data-aos-duration="1200">
          <div class="item-list">
            <carousel
              :perPage="4"
              :paginationEnabled="false"
              :navigationEnabled="true"
              :scrollPerPage="false"
              :perPageCustom = "[[0, 3], [991, 4]]"
            >
              <slide v-for="(item, index) in imageList" :key="index">
                <div class="item">
                  <img :src="`/${$staticPath}/${item.src}`" @click="changeMain(index)" :class="{active: item.isActive}">
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import HeaderBar from '../COMMON/HeaderBar.vue'

export default {
  components: {
    carousel: Carousel,
    slide: Slide,
    HeaderBar
  },
  props: ['headerBar', 'imageList'],
  data () {
    return {
      mainImg: {
        index: -1,
        src: ''
      }
    }
  },
  mounted () {
    this.mainImg.index = 0
    this.mainImg.src = this.imageList[0].src
  },
  methods: {
    changeMain: function (index) {
      this.mainImg.index = index
      this.mainImg.src = this.imageList[index].src
      this.imageList.map(el => {
        el.isActive = false
      })
      this.imageList[index].isActive = true
    }
  }
}
</script>

<style scoped>
  .content {
    padding: 120px 0;
    position: relative;
  }

  .web-img {
    width: 80%;
    padding: 35px 25px;
    background-color: rgba(190, 190, 190, 0.3);
    margin: auto;
  }

  .web-img img {
    width: 100%;
  }

  .item-list {
    padding: 10px 30px;
  }

  .item-list .item {
    padding-left: 5px;
    padding-right: 5px;
  }

  .item-list .item img {
    width: 100%;
    cursor: pointer;
    border: 2px solid rgba(0, 0, 0, 0);
  }

  .item-list .item img:hover {
    border: 2px solid #FFA500;
  }

  .item-list .item img.active {
    border: 2px solid #FFA500;
  }

  .fade-enter-active {
    transition: all 0.6s ease-in-out;
  }

  .fade-leave-active {
    transition: all 0s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  @media screen and (max-width: 991px) {
    .web-img {
      width: 100%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/DORM/Room.vue